"use client";
import { getTranslation } from "@/i18n/get-translation";
import SingleTrendingPosts from "../../single-trending-post/single-trending-post";
import { getTrendingBlogs } from "@/services/trending-blogs.service";
import { useCallback, useEffect, useState } from "react";
import { ITrendingBlogResponse } from "@/types/trending-blog.type";

const init = {
  data: [],
  meta: {
    pagination: {
      page: 0,
      pageSize: 0,
      pageCount: 0,
      total: 0,
    },
  },
};
interface ITrendingPosts {
  locale: string;
}

export default function BlogTrendingPosts({ locale }: ITrendingPosts) {
  const t = getTranslation(locale, "trendingPosts");
  const [blogs, setBlogs] = useState<ITrendingBlogResponse>(init);
  const handleFetchBlogs = useCallback(() => {
    const lang =
      locale.split("-")[0] === "en" ? "en" : `${locale.split("-")[0]}-LU`;

    getTrendingBlogs(lang)
      .then((res: ITrendingBlogResponse) => {
        setBlogs(res);
      })
      .catch(console.log);
  }, [locale]);
  useEffect(() => {
    handleFetchBlogs();
  }, [handleFetchBlogs]);

  return (
    <div className="w-full px-20 max-md:px-7 lg:pb-20 pb-10 relative">
      {blogs.data.length ? (
        <h2 className="text-primary-800 font-medium xl:text-[2.1rem] lg:text-[1.7rem] text-[1.35rem]    relative mb-6">
          {t("trendingTopics")}
        </h2>
      ) : ''}

      <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-x-5 md:gap-y-8 gap-y-6">
        {blogs.data.map((blog, key) => (
         <div key={key} className="col-span-1">
            <SingleTrendingPosts
              href={`/${locale}/blog-details?id=${blog.id}`}
              title={blog?.attributes?.blog?.data?.attributes?.title}
              imgUrl={
                blog?.attributes?.blog?.data
                  ? `${blog?.attributes?.blog?.data?.attributes?.poster?.data?.attributes?.url}`
                  : "/images/clinic-image.webp"
              }
            />
          </div>
        ))}
      </div>
    </div>
  );
}
